var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _ellipse, _ellipse2, _path12, _g, _ellipse3, _path13, _g2, _ellipse4, _path14, _g3, _path15, _path16, _path17, _ellipse5, _path18, _rect, _circle, _polygon, _path19, _polygon2, _path20, _path21, _polygon3, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _ellipse6, _g4, _path34, _rect2, _g5, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _ellipse7, _g6, _rect3, _rect4, _rect5, _ellipse8, _path48, _text, _ellipse9, _path49, _path50, _path51, _path52, _path53, _circle2, _circle3, _circle4, _path54, _path55, _text2, _path56, _text3, _path57, _path58, _path59, _circle5, _path60, _path61, _path62, _ellipse10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolutionRpa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 400.09",
    style: {
      enableBackground: "new 0 0 500 400.09"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{opacity:0.3;fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:url(#SVGID_6_);}\n\t.st7{opacity:0.3;fill:url(#SVGID_7_);}\n\t.st8{fill:url(#SVGID_8_);}\n\t.st9{fill:url(#SVGID_9_);}\n\t.st10{fill:url(#SVGID_10_);}\n\t.st11{opacity:0.3;fill:url(#SVGID_11_);}\n\t.st12{fill:url(#SVGID_12_);}\n\t.st13{fill:url(#SVGID_13_);}\n\t.st14{fill:#E9A284;}\n\t.st15{fill:#FFFFFF;}\n\t.st16{fill:url(#SVGID_14_);}\n\t.st17{fill:url(#SVGID_15_);}\n\t.st18{fill:#B6D3C3;}\n\t.st19{fill:#8CABB7;}\n\t.st20{fill:url(#SVGID_16_);}\n\t.st21{fill:url(#SVGID_17_);}\n\t.st22{fill:url(#SVGID_18_);}\n\t.st23{fill:#AA6C59;}\n\t.st24{fill:url(#SVGID_19_);}\n\t.st25{fill:url(#SVGID_20_);}\n\t.st26{fill:url(#SVGID_21_);}\n\t.st27{opacity:0.23;}\n\t.st28{fill:url(#SVGID_22_);}\n\t.st29{fill:url(#SVGID_23_);}\n\t.st30{fill:url(#SVGID_24_);}\n\t.st31{fill:url(#SVGID_25_);}\n\t.st32{fill:url(#SVGID_26_);}\n\t.st33{fill:url(#SVGID_27_);}\n\t.st34{fill:url(#SVGID_28_);}\n\t.st35{fill:url(#SVGID_29_);}\n\t.st36{fill:url(#SVGID_30_);}\n\t.st37{fill:url(#SVGID_31_);}\n\t.st38{fill:#E6CCFF;}\n\t.st39{fill:#BFBFBF;}\n\t.st40{fill:url(#SVGID_32_);}\n\t.st41{fill:url(#SVGID_33_);}\n\t.st42{fill:url(#SVGID_34_);}\n\t.st43{fill:url(#SVGID_35_);}\n\t.st44{fill:url(#SVGID_36_);}\n\t.st45{fill:url(#SVGID_37_);}\n\t.st46{fill:url(#SVGID_38_);}\n\t.st47{opacity:0.21;fill:url(#SVGID_39_);}\n\t.st48{fill:url(#SVGID_40_);}\n\t.st49{fill:url(#SVGID_41_);}\n\t.st50{fill:url(#SVGID_42_);}\n\t.st51{fill:url(#SVGID_43_);}\n\t.st52{fill:url(#SVGID_44_);}\n\t.st53{font-family:'LeagueSpartan-Bold';}\n\t.st54{font-size:12px;}\n\t.st55{fill:url(#SVGID_45_);}\n\t.st56{fill:url(#SVGID_46_);}\n\t.st57{fill:#D8D8D8;}\n\t.st58{fill:#8CABB7;stroke:#B6D3C3;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st59{fill:#B6D3C3;stroke:#8CABB7;stroke-width:0.25;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.1271,
    y1: 357.731,
    x2: 570.6551,
    y2: 357.731,
    gradientTransform: "matrix(0.9963 -0.0862 0.0862 0.9963 -20.9662 31.752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431.32,365.62c-20.3-2.05-39.49-9.86-58.54-17.14c-19.06-7.27-38.76-14.16-59.16-14.23 c-20.39-0.07-41.9,7.87-53.21,24.84c-6.99,10.48-9.42,23.43-8.36,36.06c1.15-4.81,2.87-9.47,5.27-13.83 c11.14-20.32,34.7-31.41,57.8-33.33c23.09-1.92,46.07,3.96,68.35,10.32c22.28,6.36,44.77,13.33,67.94,13.66 c16.63,0.24,33.27-3.11,48.6-9.56v-13.52C479.87,361.98,455.22,368.03,431.32,365.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.1271,
    y1: 323.9041,
    x2: 570.6605,
    y2: 323.9041,
    gradientTransform: "matrix(0.9963 -0.0862 0.0862 0.9963 -20.9662 31.752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180.38,353.94c8.14-30.39,25.62-58.19,49.34-78.85c-1.85,1.53-3.68,3.07-5.47,4.66 c-30.19,26.74-50.99,63.87-58.03,103.57c-0.98,5.52-1.68,11.09-2.13,16.67h11.03C174.63,384.5,176.36,368.93,180.38,353.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.1279,
    y1: 167.6849,
    x2: 570.6577,
    y2: 167.6849,
    gradientTransform: "matrix(0.9963 -0.0862 0.0862 0.9963 -20.9662 31.752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M392.7,90.39c-27.4-3.27-54.8-8.22-82.38-7.17c-14.04,0.53-29.82,3.73-37.29,15.63 c-7.55,12.02-3.35,27.98,3.59,40.35c6.94,12.37,16.51,23.63,19.98,37.39c5.46,21.61-5.62,44.34-20.94,60.53 c-10.19,10.76-22.18,19.54-33.98,28.55c15.11-10.79,31.89-19.31,45.76-31.64c14.66-13.03,26.1-32.13,22.95-51.49 c-2-12.33-9.54-22.93-14.69-34.31c-5.15-11.37-7.62-25.69-0.09-35.65c7.46-9.87,21.55-11.47,33.89-10.88 c24.27,1.18,47.92,7.6,71.7,12.54c23.78,4.95,48.44,8.44,72.28,3.74c9.19-1.82,18.26-5.05,26.51-9.59V76.59 c-7.85,4.73-16.39,8.42-25.13,10.95C448.36,95.2,420.1,93.66,392.7,90.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.86,
    y1: 263.2205,
    x2: 545.0255,
    y2: 263.2205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8BAAB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5D2C2"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302,316.43c23.78-7.69,49.67-7.45,74.06-1.98c16.49,3.7,32.41,9.72,48.97,13.08 c16.57,3.35,34.39,3.86,49.76-3.16c10.2-4.65,18.31-12.04,25.03-20.88V134.13c-23.04,5.7-47.52,4.29-71.18,1.14 c-26.58-3.53-53.04-9.15-79.86-8.91c-8.34,0.07-17.89,1.38-22.51,8.33c-7.21,10.86,3.05,24.29,8.13,36.29 c8.51,20.14,1.35,43.88-11.1,61.85c-12.46,17.97-58.98,43.94-84.48,61.77c-37.33,26.1-48.16,55.49-42.75,105.5h38.71 c0.62-13.17,3.83-26.06,10.16-37.86C256.75,340.2,278.22,324.13,302,316.43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.0446,
    y1: 270.3734,
    x2: 545.2115,
    y2: 270.3734
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF91D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6179,
    style: {
      stopColor: "#FF9DA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC3BE"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M229.72,275.09c3.91-3.23,7.92-6.35,11.96-9.43c-0.86,0.61-1.72,1.23-2.57,1.86 C235.89,269.92,232.76,272.45,229.72,275.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.6173,
    y1: 258.981,
    x2: 436.6182,
    y2: 318.981
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF91D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6179,
    style: {
      stopColor: "#FF9DA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC3BE"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M229.72,275.09c3.91-3.23,7.92-6.35,11.96-9.43c-0.86,0.61-1.72,1.23-2.57,1.86 C235.89,269.92,232.76,272.45,229.72,275.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.7641,
    y1: 220.4699,
    x2: 445.7643,
    y2: 280.4697
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5D2C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BAAB6"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M238.82,294.56c25.5-17.83,72.02-43.8,84.48-61.77c12.45-17.97,19.61-41.71,11.1-61.85 c-5.08-12-15.34-25.43-8.13-36.29c4.62-6.95,14.17-8.26,22.51-8.33c26.82-0.24,53.28,5.38,79.86,8.91 c23.66,3.15,48.14,4.56,71.18-1.14v-25.66c-8.25,4.55-17.32,7.78-26.51,9.59c-23.84,4.7-48.5,1.21-72.28-3.74 c-23.78-4.94-47.43-11.36-71.7-12.54c-12.34-0.59-26.43,1.01-33.89,10.88c-7.53,9.96-5.06,24.28,0.09,35.65 c5.15,11.38,12.69,21.98,14.69,34.31c3.15,19.36-8.29,38.46-22.95,51.49c-13.87,12.33-30.65,20.85-45.76,31.64 c-4.04,3.09-8.05,6.2-11.96,9.43c-23.72,20.66-41.21,48.46-49.34,78.85c-4.02,14.99-5.75,30.56-5.25,46.06h21.13 C190.66,350.05,201.48,320.66,238.82,294.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.0443,
    y1: 397.5754,
    x2: 545.2115,
    y2: 397.5754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF91D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6179,
    style: {
      stopColor: "#FF9DA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC3BE"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M251.07,400h1.57c-0.25-1.61-0.45-3.22-0.59-4.85C251.66,396.75,251.32,398.37,251.07,400z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.2839,
    y1: 375.7628,
    x2: 549.6196,
    y2: 256.4284
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF91D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6179,
    style: {
      stopColor: "#FF9DA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC3BE"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M251.07,400h1.57c-0.25-1.61-0.45-3.22-0.59-4.85C251.66,396.75,251.32,398.37,251.07,400z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.1269,
    y1: 349.3163,
    x2: 570.6566,
    y2: 349.3163,
    gradientTransform: "matrix(0.9963 -0.0862 0.0862 0.9963 -20.9662 31.752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD7E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M260.41,359.09c11.31-16.97,32.82-24.91,53.21-24.84c20.4,0.07,40.1,6.96,59.16,14.23 c19.05,7.28,38.24,15.09,58.54,17.14c23.9,2.41,48.55-3.64,68.68-16.74V303.4c-6.72,8.84-14.83,16.23-25.03,20.88 c-15.37,7.02-33.19,6.51-49.76,3.16c-16.56-3.36-32.48-9.38-48.97-13.08c-24.39-5.47-50.28-5.71-74.06,1.98 c-23.78,7.7-45.25,23.77-57.06,45.8c-6.32,11.8-9.54,24.69-10.16,37.86h16.11c0.25-1.63,0.59-3.25,0.98-4.85 C250.99,382.52,253.42,369.57,260.41,359.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.4803,
    y1: 380.3898,
    x2: 551.8137,
    y2: 261.0565
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5D2C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BAAB6"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M260.41,359.09c11.31-16.97,32.82-24.91,53.21-24.84c20.4,0.07,40.1,6.96,59.16,14.23 c19.05,7.28,38.24,15.09,58.54,17.14c23.9,2.41,48.55-3.64,68.68-16.74V303.4c-6.72,8.84-14.83,16.23-25.03,20.88 c-15.37,7.02-33.19,6.51-49.76,3.16c-16.56-3.36-32.48-9.38-48.97-13.08c-24.39-5.47-50.28-5.71-74.06,1.98 c-23.78,7.7-45.25,23.77-57.06,45.8c-6.32,11.8-9.54,24.69-10.16,37.86h16.11c0.25-1.63,0.59-3.25,0.98-4.85 C250.99,382.52,253.42,369.57,260.41,359.09z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 239.3063,
    cy: 168.5008,
    r: 4.7993,
    gradientTransform: "matrix(3.9319 0 0 3.7956 -652.7988 -490.0758)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9AB8BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 288.13,
    cy: 149.49,
    rx: 18.87,
    ry: 18.22
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 265.2023,
    cy: 194.8342,
    r: 3.2864,
    gradientTransform: "matrix(3.9319 0 0 3.7956 -652.7988 -490.0758)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 389.95,
    cy: 249.44,
    rx: 12.92,
    ry: 12.47
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M297.21,157.46h-18.16c-2.39,0-4.32-1.94-4.32-4.32v-18.16c0-2.39,1.94-4.32,4.32-4.32h18.16 c2.39,0,4.32,1.94,4.32,4.32v18.16C301.53,155.53,299.6,157.46,297.21,157.46z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M284.08,143.6c-0.12,0.19-0.32,0.33-0.58,0.41c0.27,0.08,0.46,0.22,0.58,0.41c0.12,0.19,0.18,0.48,0.18,0.87 v1.83c0,0.27,0.07,0.48,0.21,0.63c0.14,0.14,0.35,0.22,0.62,0.22h0.21v1.39h-0.66c-0.71,0-1.25-0.18-1.61-0.53 c-0.37-0.35-0.55-0.86-0.55-1.52v-2.07c0-0.18-0.04-0.31-0.13-0.4c-0.09-0.09-0.21-0.14-0.37-0.14h-0.38v-1.39h0.38 c0.16,0,0.28-0.05,0.37-0.14c0.09-0.09,0.13-0.22,0.13-0.4v-2.07c0-0.66,0.18-1.17,0.55-1.52c0.37-0.35,0.9-0.53,1.61-0.53h0.66 v1.39h-0.21c-0.27,0-0.48,0.07-0.62,0.22c-0.14,0.15-0.21,0.35-0.21,0.63v1.83C284.26,143.12,284.2,143.41,284.08,143.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M289.36,137.52h1.59l-3.77,10.77h-1.59L289.36,137.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M294.66,143.31v1.39h-0.38c-0.16,0-0.28,0.05-0.37,0.14c-0.09,0.09-0.13,0.22-0.13,0.4v2.07 c0,0.66-0.18,1.17-0.55,1.52c-0.37,0.35-0.9,0.53-1.61,0.53h-0.66v-1.39h0.21c0.27,0,0.48-0.07,0.62-0.22 c0.14-0.14,0.21-0.35,0.21-0.63v-1.83c0-0.39,0.06-0.68,0.18-0.87c0.12-0.19,0.32-0.33,0.58-0.41c-0.27-0.08-0.46-0.22-0.58-0.41 c-0.12-0.19-0.18-0.48-0.18-0.87v-1.83c0-0.27-0.07-0.48-0.21-0.63c-0.14-0.14-0.35-0.22-0.62-0.22h-0.21v-1.39h0.66 c0.71,0,1.25,0.18,1.61,0.53c0.37,0.35,0.55,0.86,0.55,1.52v2.07c0,0.18,0.04,0.31,0.13,0.4c0.09,0.09,0.21,0.14,0.37,0.14H294.66 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 259.6492,
    cy: 158.1491,
    r: 4.2504,
    gradientTransform: "matrix(3.9319 0 0 3.7956 -652.7988 -490.0758)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st16",
    cx: 368.12,
    cy: 110.19,
    rx: 16.71,
    ry: 16.13
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M373.88,119.27h-11.54c-5.99,0-10.89-4.9-10.89-10.89l0,0c0-5.99,4.9-10.89,10.89-10.89h11.54 c5.99,0,10.89,4.9,10.89,10.89l0,0C384.78,114.37,379.88,119.27,373.88,119.27z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M363.37,111.53c-0.38-0.17-0.69-0.41-0.93-0.72l0.86-1.03c0.36,0.49,0.78,0.74,1.24,0.74 c0.63,0,0.95-0.37,0.95-1.11v-3.18h-2.35v-1.24h3.89v4.34c0,0.82-0.2,1.44-0.61,1.85c-0.41,0.41-1.01,0.62-1.8,0.62 C364.17,111.79,363.75,111.7,363.37,111.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M369.22,111.57c-0.49-0.14-0.89-0.33-1.19-0.56l0.53-1.17c0.29,0.21,0.63,0.38,1.02,0.51 c0.39,0.13,0.79,0.19,1.18,0.19c0.44,0,0.76-0.07,0.97-0.2c0.21-0.13,0.31-0.3,0.31-0.52c0-0.16-0.06-0.29-0.19-0.4 c-0.12-0.1-0.28-0.19-0.48-0.25c-0.19-0.06-0.46-0.13-0.79-0.21c-0.51-0.12-0.93-0.24-1.25-0.36c-0.32-0.12-0.6-0.32-0.84-0.58 c-0.23-0.27-0.35-0.62-0.35-1.07c0-0.39,0.1-0.74,0.32-1.06c0.21-0.32,0.53-0.56,0.95-0.75c0.42-0.18,0.94-0.28,1.55-0.28 c0.43,0,0.84,0.05,1.25,0.15c0.41,0.1,0.76,0.25,1.07,0.44l-0.48,1.17c-0.62-0.35-1.24-0.53-1.85-0.53 c-0.43,0-0.75,0.07-0.96,0.21c-0.21,0.14-0.31,0.32-0.31,0.55c0,0.23,0.12,0.4,0.36,0.51c0.24,0.11,0.6,0.22,1.09,0.33 c0.51,0.12,0.93,0.24,1.25,0.36c0.32,0.12,0.6,0.31,0.84,0.57c0.23,0.26,0.35,0.61,0.35,1.06c0,0.38-0.11,0.73-0.32,1.05 c-0.21,0.32-0.53,0.57-0.96,0.75c-0.43,0.18-0.95,0.28-1.56,0.28C370.22,111.79,369.71,111.71,369.22,111.57z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 260.3249,
    cy: 181.7541,
    r: 8.7559,
    gradientTransform: "matrix(3.9319 0 0 3.7956 -652.7988 -490.0758)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 370.77,
    cy: 199.79,
    rx: 34.43,
    ry: 33.23
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M398.71,221h-54.78c-4.16,0-7.54-3.38-7.54-7.54v-41.89c0-4.16,3.38-7.54,7.54-7.54h54.78 c4.16,0,7.54,3.38,7.54,7.54v41.89C406.25,217.62,402.87,221,398.71,221z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 345.84,
    y: 180.93,
    className: "st15",
    width: 1.95,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.84,
    y: 185.17,
    className: "st15",
    width: 1.95,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.84,
    y: 189.41,
    className: "st15",
    width: 1.95,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.84,
    y: 193.65,
    className: "st15",
    width: 1.95,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.84,
    y: 197.89,
    className: "st15",
    width: 1.95,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.84,
    y: 202.13,
    className: "st15",
    width: 1.95,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.84,
    y: 206.37,
    className: "st15",
    width: 1.95,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.84,
    y: 210.61,
    className: "st15",
    width: 1.95,
    height: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 352.4,
    y: 180.93,
    className: "st15",
    width: 17.44,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.32,
    y: 180.93,
    className: "st18",
    width: 4.43,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.89,
    y: 185.17,
    className: "st15",
    width: 13.72,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.51,
    y: 185.17,
    className: "st15",
    width: 10.97,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.09,
    y: 185.17,
    className: "st19",
    width: 6.89,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.32,
    y: 189.41,
    className: "st19",
    width: 6.89,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.76,
    y: 189.41,
    className: "st18",
    width: 16.72,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.4,
    y: 206.37,
    className: "st15",
    width: 17.44,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.32,
    y: 206.37,
    className: "st19",
    width: 4.43,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.89,
    y: 210.61,
    className: "st15",
    width: 13.72,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.09,
    y: 210.61,
    className: "st18",
    width: 19.39,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.4,
    y: 193.65,
    className: "st15",
    width: 6.47,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.35,
    y: 193.65,
    className: "st18",
    width: 15.4,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.89,
    y: 197.89,
    className: "st19",
    width: 6.12,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.51,
    y: 197.89,
    className: "st15",
    width: 10.97,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.49,
    y: 197.89,
    className: "st15",
    width: 14.49,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.32,
    y: 202.13,
    className: "st15",
    width: 17.02,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.89,
    y: 202.13,
    className: "st19",
    width: 6.59,
    height: 1.5
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M396.69,172.37c0,0.76-0.61,1.37-1.37,1.37c-0.76,0-1.37-0.62-1.37-1.37c0-0.76,0.61-1.37,1.37-1.37 C396.07,170.99,396.69,171.61,396.69,172.37z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M391.98,172.37c0,0.76-0.62,1.37-1.37,1.37s-1.37-0.62-1.37-1.37c0-0.76,0.62-1.37,1.37-1.37 S391.98,171.61,391.98,172.37z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M387.27,172.37c0,0.76-0.61,1.37-1.37,1.37c-0.76,0-1.37-0.62-1.37-1.37c0-0.76,0.62-1.37,1.37-1.37 C386.65,170.99,387.27,171.61,387.27,172.37z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 220.3883,
    cy: 210.5337,
    r: 5.8959,
    gradientTransform: "matrix(3.9319 0 0 3.7956 -652.7988 -490.0758)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9AB8BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 213.75,
    cy: 309.03,
    rx: 23.18,
    ry: 22.38
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.6644,
    y1: 309.5655,
    x2: 213.8349,
    y2: 285.4371
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFA092"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M191.4,310.98v-25.82c0-1.03,0.84-1.87,1.87-1.87h40.96c1.03,0,1.87,0.84,1.87,1.87v25.82H191.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 193.23,
    y: 285.22,
    className: "st15",
    width: 41.03,
    height: 21.86
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 213.75,
    cy: 309.03,
    r: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.7457,
    y1: 318.8152,
    x2: 213.7457,
    y2: 310.674
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFA092"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "242.72,315.92 184.77,315.92 191.4,310.98 236.09,310.98  "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M240.14,318.49h-52.79c-1.42,0-2.58-1.15-2.58-2.58l0,0h57.94l0,0 C242.72,317.34,241.56,318.49,240.14,318.49z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.0931,
    y1: 317.5702,
    x2: 310.1084,
    y2: 317.5702
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCCA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E59B6C"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "308.6,321.85 303.09,320.73 304.6,313.29 310.11,314.41  "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M304.23,315.78c-0.53-0.63-3.29,1.17-3.82,2.27c-0.81,1.67,0.89,3.17,2.14,6.61 c2.08,5.76,8.1,11.35,9.13,9.89c2.28-3.22-1.1-6.07-2.02-14.01c-0.18-1.58-1.37-1.43-2.61-0.13c-1.24,1.31-2.96,0.12-3.18-1.25 C303.88,319.17,303.56,317.12,304.23,315.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.2074,
    y1: 283.2907,
    x2: 312.6119,
    y2: 283.2907
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D9A27E"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M302.51,251.79c1.78,3.81,8.57,20.15,9.58,32.93c1.49,18.82-0.61,28.76-1.62,30.47 c-1.01,1.71-7.6,1.39-7.25-1.89s0.28-16.7-1.86-26.99c-3.86-18.56-12.95-25.03-13.15-29.96 C288,251.42,300.96,248.47,302.51,251.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.616,
    y1: 307.7934,
    x2: 284.6415,
    y2: 307.7934
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCCA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E59B6C"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "280.71,312.47 275.62,311.11 276.93,307.64 280.99,303.12 284.64,308.52  "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M290.44,267.06c0.38,0.17,1.17-1.87,1.53-1.88c2.3,0,11.86,10.03,12.83,12.11c1.59,3.39,2.83,5.12,2.62,9.3 c-0.33,6.92-4.59,10.16-4.59,10.16s-2.16-11.74-2.74-14.99C299.51,278.51,290.44,267.06,290.44,267.06z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M277.86,306.6c-1.35-1-2.07,2.25-2.56,3.37c-0.75,1.7-0.47,8.82,0.64,12.31c2.25,7.09,6.14,4.81,6.37,3.04 c0.81-6.38,0.06-6.84,0.83-14.07c0.17-1.58-3.28-1.38-4.47-0.03C277.48,312.57,277.24,307.96,277.86,306.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.4628,
    y1: 286.5202,
    x2: 295.6294,
    y2: 267.0203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D9A27E"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M288.75,247.56c-6.66,2.73-12.57,5.88-9,17.32c3.69,11.84,10.69,16.01,13.57,20.72 c1.49,2.43-8.39,11.98-12.47,16.59c-2.39,2.7,0.73,9.42,5.7,5.89c14.62-10.38,21.01-18.85,17.99-25.64 c-6.84-15.39-12.35-20.77-15.79-29.98C286.8,247.26,288.75,247.56,288.75,247.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 352.7373,
    y1: 201.2192,
    x2: 322.6379,
    y2: 198.0443,
    gradientTransform: "matrix(0.9945 -0.1049 0.1049 0.9945 -29.2701 43.6295)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCCA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E59B6C"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M340.44,192.46c-1.95,0.68-3.19,0.54-4.42,0.84c-1.34,0.32-1.55,0.32-2.84,1.28 c-1.29,0.96-2.15,2.89-2.9,4.18c-0.33,0.57-0.59,1.02-0.77,1.34c-0.99,1.72-10.69,8.25-17.13,14.12c0,0,3.32,8.02,4.62,6.88 c7.56-6.62,13.38-16.26,16.26-19.54c1.55-0.29,3.69-0.28,4.11-0.47c0.67-0.3,3.5-3.28,3.17-3.54c-0.93-0.24-1.91,0.73-2.48,1.11 c-0.57,0.38-1.25,0.01-1.25,0.01c1.73-1.29,3.24-4.86,5.04-5.43C343.64,192.68,342.03,191.91,340.44,192.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.2051,
    y1: 221.2045,
    x2: 317.5094,
    y2: 217.4153
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CABB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B6D3C3"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M302.55,215.41c3.51,0.44,8.51-1.81,9.63-2.31s5.25,5.19,4.81,8s-6.94,6.38-11.12,5.5 S302.55,215.41,302.55,215.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.5743,
    y1: 240.115,
    x2: 313.2713,
    y2: 230.3536
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CABB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B6D3C3"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M307.8,226.1c0.14,8.47-5.28,13.04-3.88,27.25c0.27,2.73-4.2,4.51-9.07,5.27c-5.86,0.92-12.74,0.4-14.65-1.6 c-3.5-3.67,3.55-10.25,2.81-17.25c-0.07-0.62-0.17-1.27-0.29-1.94c-1.28-6.48-5.07-14.57-1.8-17.33 c5.15-4.33,11.6-8.35,17.81-6.58C304.76,215.64,307.68,218.47,307.8,226.1z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M297.19,258.15c-8.26,1.94-15.08,0.86-16.99-1.14c-3.5-3.67,3.55-10.25,2.81-17.25 c-0.07-0.62-0.17-1.27-0.29-1.94l4.31-12.92c4.46,8.56-0.54,8.54,2.96,17.88C292.03,248.24,288.68,259.72,297.19,258.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.557,
    y1: 274.164,
    x2: 300.7884,
    y2: 251.2301,
    gradientTransform: "matrix(0.9995 -0.0302 0.0302 0.9995 -10.8645 -1.2166)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCCA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E59B6C"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M302.58,276.29c-1.77-0.88-2.76-4.85-4.35-6.47c0,0,0.77-0.27,1.3,0.22c0.53,0.49,1.39,1.66,2.39,1.56 c0.39-0.21-2.07-3.77-2.71-4.2c-0.46-0.3-3.18-1.42-4.69-2.14c-1.56-2.72-5.98-15.56-7.76-19.38c-2.11-4.55-1.12-11.35-1.44-14.15 c-0.32-2.8-7.7-1.83-7.75,1.2c-0.12,7.38,0.62,12.93,1.36,14.9c4.82,12.89,8.69,14.64,11.93,19.31c0,0,0,0,0,0 c0.14,0.37,0.33,0.88,0.58,1.53c0.57,1.46,1.15,3.61,2.33,4.82c1.18,1.21,1.4,1.24,2.74,1.8c1.24,0.51,2.54,0.57,4.46,1.59 C302.56,277.71,304.36,277.17,302.58,276.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.2435,
    y1: 301.4114,
    x2: 408.091,
    y2: 295.903,
    gradientTransform: "matrix(0.9406 -0.3396 0.3396 0.9406 -189.4756 72.8499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCCA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E59B6C"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M295.28,218.05L295.28,218.05c-2.09,0.19-3.95-1.36-4.13-3.45l-0.44-4.93l7.59-0.68l0.44,4.93 C298.92,216.01,297.38,217.86,295.28,218.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.1119,
    y1: 290.0409,
    x2: 417.958,
    y2: 286.0848,
    gradientTransform: "matrix(0.9406 -0.3396 0.3396 0.9406 -189.4756 72.8499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCCA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E59B6C"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M296.45,196.46c-1.51-1.3-7.49,1.6-8.95,3.01c0,0-0.87,1.61-0.88,1.61c-1.78,1.71,1.35,1.66,1.28,4.16 c-0.46,0.05-0.59,0.39-0.85,0.74c-0.58,0.79-0.24,2.74,0.79,3.49c0.67,0.49,1.45,0.65,2.07,0.48c0.33,0.27,0.67,0.52,1.01,0.74 c0.05,0.04,0.1,0.07,0.16,0.09c1.6,0.97,5.49,1.79,8.77,0.51c0.9-1.15,1.12-4.98-0.59-8.34 C298.48,199.57,297.58,197.43,296.45,196.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.5762,
    y1: 218.337,
    x2: 368.7977,
    y2: 218.337,
    gradientTransform: "matrix(0.9979 -0.0653 0.0653 0.9979 -84.2647 5.6824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#554E00"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M284.74,199.84c-2.35,2.93,1.11,6.47,2.14,7.13c-0.03-1.28,1.51-2.4,2.63-0.28l1.98-1.22 c0.04-0.85-0.21-1.11-0.54-2.38c-0.3-1.12-1.1-2.37-1.1-2.37c4.05-0.35,7.2-1.38,8.07-2.14c0.23-4.64-4.42-7.9-7.99-3.5 C286.1,194.8,283.55,197.29,284.74,199.84z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.4881,
    y1: 234.8973,
    x2: 297.7382,
    y2: 218.2722
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CABB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B6D3C3"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M281.09,220.41c-2.92,2.65-5.79,11.05-4.38,16.27c0.86,3.2,9.79,3.23,10.35,0.34c0.88-4.51,1-11.4-0.5-13.85 C285.18,220.91,282.54,219.09,281.09,220.41z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_31_",
    cx: 281.7006,
    cy: 170.1521,
    r: 4.8748,
    gradientTransform: "matrix(3.9319 0 0 3.7956 -652.7988 -490.0758)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9AB8BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st37",
    cx: 454.82,
    cy: 155.75,
    rx: 19.17,
    ry: 18.5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M467.78,146.71c-0.43-3.32-3.26-5.89-6.7-5.89c-1.47,0-2.83,0.48-3.94,1.28c-0.55-3.76-3.77-6.64-7.68-6.64 c-4.29,0-7.77,3.48-7.77,7.77v3.49c-4.13,0.32-7.39,3.76-7.39,7.98v0c0,4.42,3.59,8.01,8.01,8.01h25.04 c4.42,0,8.01-3.59,8.01-8.01v0C475.35,150.42,471.99,146.94,467.78,146.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M459.53,158.34l-5.15-8.91c-0.17-0.29-0.59-0.29-0.76,0l-5.15,8.91c-0.17,0.29,0.04,0.66,0.38,0.66h1.3 c0.24,0,0.44,0.2,0.44,0.44v6.69c0,0.24,0.2,0.44,0.44,0.44h5.94c0.24,0,0.44-0.2,0.44-0.44v-6.69c0-0.24,0.2-0.44,0.44-0.44h1.3 C459.49,159,459.7,158.63,459.53,158.34z"
  })))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M397.29,255.7h-14.67c-2.43,0-4.39-1.97-4.39-4.39v-12.98c0-2.43,1.97-4.39,4.39-4.39h14.67 c2.43,0,4.39,1.97,4.39,4.39v12.98C401.68,253.73,399.71,255.7,397.29,255.7z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 481.14,
    y: 317.43,
    transform: "matrix(-0.7789 0.6271 -0.6271 -0.7789 1062.1946 266.9261)",
    className: "st38",
    width: 5.81,
    height: 6.5
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M483.9,339.33c-1-1.49-1.91-2.37-0.99-7.04c0.57-2.88-0.83-7.13-0.36-8.21c0.4-0.92,0.9,1.09,2.06-0.31 c0.86-1.04-0.3-1.63-0.23-2.33c0.22-2.01,2.3-2.73,3.51-2.18c0.84,0.38,2.55,1.97,2.82,3.17c0.27,1.2-3.01,6.69-3.12,6.95 C487.48,329.64,483.9,339.33,483.9,339.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M490.86,322.84c-0.27-1.43-2.52-1.99-3.55-0.63c-1.03,1.36-1.59,3.35-1.6,5.71 c-0.01,3.61-1.71,4.25-2.26,8.13c-0.51,3.6,1.49,4.84,2.98,3.88c1.49-0.96,4.23-3.51,4.45-8.21 C491.03,328.44,491.31,325.21,490.86,322.84z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.2702,
    y1: -393.4112,
    x2: 259.6136,
    y2: -403.43,
    gradientTransform: "matrix(0.2196 -1.032 0.9684 0.1842 732.7098 589.4537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDCC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD8DF"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M409.2,255.31c-1.08-0.59-1.23-5-1.55-5.59c-0.35-0.64-3.52-3.26-3.76-2.91c-0.17,0.94,0.87,1.85,1.29,2.39 s0.1,1.25,0.1,1.25c-1.41-1.63-5.08-2.89-5.78-4.64c-0.69-1.75-1.35-0.09-0.68,1.46c0.81,1.9,0.76,3.14,1.15,4.35 c0.42,1.31,0.43,1.52,1.48,2.74c1.05,1.22,3.04,1.94,4.37,2.6c1.33,0.66,2.04,0.97,2.04,0.97L409.2,255.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.1534,
    y1: -394.5862,
    x2: 308.4966,
    y2: -404.6048,
    gradientTransform: "matrix(-0.9941 0.3535 0.3101 0.9357 834.969 473.0688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDCC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD8DF"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M412.18,212.54c-0.73-0.99-5.11-0.56-5.75-0.8c-0.68-0.26-3.69-3.06-3.38-3.34c0.91-0.29,1.95,0.62,2.54,0.96 c0.59,0.34,1.25-0.06,1.25-0.06c-1.8-1.18-3.53-4.66-5.36-5.11c-1.83-0.46-0.27-1.32,1.36-0.87c1.99,0.56,3.21,0.34,4.47,0.57 c1.35,0.24,1.57,0.23,2.91,1.11c1.34,0.88,2.32,2.76,3.15,3.99c0.83,1.24,1.23,1.9,1.23,1.9L412.18,212.54z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.2588,
    y1: 288.6341,
    x2: 486.2175,
    y2: 288.6341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CABB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B6D3C3"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M486.15,318.66c-3.7-0.94-3.74,4.29-5.28,3.19c-1.3-0.93-7.56-4.74-13.11-9.83l0.47-1.14l-2.28-0.59 c-2.82-2.83-5.26-5.95-6.51-9.14c-1.42-3.64-1.91-11.95-3.13-18.46c-5.82,6.91-13.09,14.42-9.13,16.5 c5.23,2.76,12.74,7.77,14.42,9.08c0.26,0.2,0.42,0.56,0.51,1.02c0.38,1.89-0.54,5.41-1.82,5.88c-0.18,0.08-0.36,0.08-0.55,0.02 c-1.63-0.56-27.79-10.51-26.43-16c1.41-5.71,4.69-20.81,12.14-30.04c0,0,3.58-9.84,8.25-12.22c0.63-2.98,3.22,0.15,3.22,0.15 s-0.21-3.49,1.85-0.79c1.08,0.79,1.96,1.97,2.47,3.44c1.64,2.46,2.58,2.48,3.84,3.56c8.47,7.35,1.82,27.52,4.84,34.96 C473.18,306.3,487.31,318.95,486.15,318.66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.95,
    y1: 311.155,
    x2: 468.23,
    y2: 311.155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#493EB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#633AFF"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M468.23,310.88l-0.47,1.14c-0.62-0.56-1.22-1.14-1.81-1.73L468.23,310.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.6361,
    y1: 313.1171,
    x2: 466.7332,
    y2: 309.9033
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7BDFF"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M468.23,310.88l-1.49,3.61c-1-1.59-1.99-3.21-2.9-4.75L468.23,310.88z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M468.23,310.88l-0.47,1.14l-1.02,2.47l-1.08,2.61l-5.37-1.93c1.28-0.47,2.2-3.99,1.82-5.88l1.73,0.45 l2.11,0.55L468.23,310.88z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M452.68,227.97c-8.07-4.87-13.34-5.05-18.01-7.32c-4.67-2.27-17.05-9.67-19.17-10.67 c-2.12-1-6.25,2.65-4.75,3.77s13.38,10.25,15.75,12s16.97,10.62,21.92,10.25C453.38,235.62,455.52,229.69,452.68,227.97z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M463.57,309.44c0.23-0.96,3.52-0.03,4.69,0.86c1.76,1.36,2.55,2.69,2.11,7.31 c-0.7,7.31-1.94,14.55-4.35,13.93c-4.58-1.18-2.06-5.36-5.35-14.35c-0.66-1.79,0.7-2.28,2.73-1.54c2.03,0.73,2.97-1.41,2.73-3.05 C465.98,311.59,465.18,310.01,463.57,309.44z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M456.31,282.69c0.94-1.15,2.46-2.73,3.43-3.4c0.72,2.58-1.45,9.21-0.57,13.21s-0.95,3.77-0.6,5.36 C457.93,293.93,456.31,282.69,456.31,282.69z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M459.74,248.6c-1.59-6.73-0.49-15.71-3.86-19.66c-7.78-9.11-18.77,4.92-20.77,8.56 c-0.01,0.02-0.02,0.03-0.03,0.05c-2.89,3.65-4.45,11.44-6.93,15.83c-1.66,2.94-14.44,1.42-17.99,0.29s-5.33,4.32-3.29,5.71 c4.46,3.04,22.02,6.04,26.38,2.19c2.76-2.43,4.92-5.67,6.51-8.96c2.81,3.48,5.31,8.06,4.73,16.42c-0.39,5.66,22.64,0.13,22.5-4.36 C466.9,261.6,461.33,255.33,459.74,248.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.6765,
    y1: 274.4588,
    x2: 149.3336,
    y2: 274.4588,
    gradientTransform: "matrix(-0.9669 0.2552 0.2552 0.9669 509.2301 -80.0603)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDCC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD8DF"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M434.67,220.65c0.28-2.97-1.6-5.64-0.69-6.56c0.71-0.72,4.58-5.06,10.03-3.92c4.48,0.94,4.56,9.45,4.45,12.45 c0,0,0,0,0,0c1.14,2.72,1.79,4.88,1.79,4.88c0.96,2.07-1.51,3.7-2.49,4.2c-0.7,0.36-4.83,1.88-5.42-0.38 c-0.22-0.85-0.82-3.43-0.82-3.43c-1.32,0.84-3.46,0.8-4.29-0.36C435.84,225.6,434.36,223.9,434.67,220.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.6499,
    y1: 260.0673,
    x2: 138.7246,
    y2: 276.2049,
    gradientTransform: "matrix(-0.9669 0.2552 0.2552 0.9669 509.2301 -80.0603)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.614687e-7,
    style: {
      stopColor: "#FFC45A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD77A"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M446.58,224.28c-0.87,0.33-4.03-0.57-4.14-2.62c-0.11-2.05-0.63-3.19-1.78-2.96 c-0.48,0.1-0.86,0.72-0.59,1.71c0.13,0.48-2.33-0.67-2.36-1.04c-0.13-1.81,3.26-3.62-2.7-3.35c-1.7,0.08-3.04-1-3.17-2.62 c0.69-3.42,6.16-8,10.5-4.66c1.62-1.16,4.66,0.44,4.69,1.55c2.6,0.76,3.81,4.89,2.31,8.32c-1.14,2.61-0.37,3.62-0.84,4.67 C447.74,223.84,446.58,224.28,446.58,224.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 446.0712,
    y1: 253.9019,
    x2: 440.1802,
    y2: 258.3503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222321"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#393938"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M439.77,252.6c1.15-2.35,1.74-4.54,2.33-6.48c2.53,4.44,4.28,12.5,2.47,19.69 C444,259.38,441.79,255.39,439.77,252.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_40_",
    cx: 230.2808,
    cy: 224.6637,
    r: 3.0364,
    gradientTransform: "matrix(3.9319 0 0 3.7956 -652.7988 -490.0758)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st48",
    cx: 252.64,
    cy: 362.66,
    rx: 11.94,
    ry: 11.53
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 252.64,
    cy: 359.54,
    r: 10.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M256.87,359.33l-3.49,3.83c-0.4,0.43-1.08,0.43-1.48,0l-3.49-3.83c-0.3-0.33-0.35-0.81-0.12-1.19l1.24-2.06 c0.18-0.3,0.51-0.48,0.86-0.48h4.51c0.35,0,0.68,0.18,0.86,0.48l1.24,2.06C257.22,358.52,257.17,359.01,256.87,359.33z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.119,
    y1: 241.9492,
    x2: 394.7814,
    y2: 241.9492
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFA092"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 385.12,
    y: 241.35,
    className: "st49",
    width: 9.66,
    height: 1.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.119,
    y1: 244.8121,
    x2: 394.7814,
    y2: 244.8121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFA092"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 385.12,
    y: 244.22,
    className: "st50",
    width: 9.66,
    height: 1.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.119,
    y1: 247.675,
    x2: 394.7814,
    y2: 247.675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFA092"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 385.12,
    y: 247.08,
    className: "st51",
    width: 9.66,
    height: 1.19
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_44_",
    cx: 229.19,
    cy: 226.5213,
    r: 5.341,
    gradientTransform: "matrix(5.7078 -2.253499e-05 -2.997463e-05 2.7546 -1135.4385 -256.1911)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9AB8BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st52",
    cx: 172.73,
    cy: 367.78,
    rx: 30.49,
    ry: 14.71
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M193.62,372.63h-40.64c-5.05,0-9.15-4.09-9.15-9.15v0c0-5.05,4.09-9.15,9.15-9.15h40.64 c5.05,0,9.15,4.09,9.15,9.15v0C202.77,368.54,198.67,372.63,193.62,372.63z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 151.108 367.7087)",
    className: "st15 st53 st54"
  }, "Python")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_45_",
    cx: 264.6928,
    cy: 213.9526,
    r: 5.8959,
    gradientTransform: "matrix(4.9975 0 0 2.5231 -936.0112 -218.5422)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9AB8BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st55",
    cx: 386.78,
    cy: 321.29,
    rx: 29.46,
    ry: 14.88
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M407.1,324.8h-40.64c-5.05,0-9.15-4.09-9.15-9.15v0c0-5.05,4.09-9.15,9.15-9.15h40.64 c5.05,0,9.15,4.09,9.15,9.15v0C416.25,320.7,412.15,324.8,407.1,324.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_46_",
    cx: 277.4217,
    cy: 153.9598,
    r: 4.8809,
    gradientTransform: "matrix(5.7078 -2.626722e-05 -2.997463e-05 3.2108 -1135.4391 -397.4821)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9AB8BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M478.52,99.96c0,9.47-13.26,10.93-30.09,10.93c-16.84,0-30.88-1.46-30.88-10.93 c0-9.47,13.65-17.15,30.49-17.15C464.87,82.81,478.52,90.49,478.52,99.96z"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M328.75,103.91h-22.16c-2.22,0-4.02-1.8-4.02-4.02V83.24c0-2.22,1.8-4.02,4.02-4.02h22.16 c2.22,0,4.02,1.8,4.02,4.02v16.64C332.77,102.1,330.97,103.91,328.75,103.91z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M301.68,96.76h-0.76c-0.49,0-0.88-0.39-0.88-0.88v-8.01c0-0.49,0.39-0.88,0.88-0.88h0.76 c0.49,0,0.88,0.39,0.88,0.88v8.01C302.56,96.36,302.17,96.76,301.68,96.76z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M316.08,79.21c1.7-0.75,1.26-5.58,1.26-5.58h0.82c0,0-0.6,5.21,1.1,5.58H316.08z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 317.67,
    cy: 72.16,
    r: 3.55
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st58",
    cx: 311.26,
    cy: 89.52,
    r: 3.55
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st58",
    cx: 324.77,
    cy: 89.52,
    r: 3.55
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M312.32,96.44c0,0.03-0.01,0.07-0.01,0.1v0.21c0,1.4,0.72,2.54,1.62,2.54h7.48c0.89,0,1.62-1.14,1.62-2.54 v-0.21c0-0.04-0.01-0.07-0.01-0.1H312.32z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M334.41,96.44h-0.76c-0.49,0-0.88-0.39-0.88-0.88v-8.01c0-0.49,0.39-0.88,0.88-0.88h0.76 c0.49,0,0.88,0.39,0.88,0.88v8.01C335.29,96.05,334.9,96.44,334.41,96.44z"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 364.9521 320.3061)",
    className: "st15 st53 st54"
  }, "Robotic")), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M470.15,100.28h-40.64c-5.05,0-9.15-4.09-9.15-9.15v0c0-5.05,4.09-9.15,9.15-9.15h40.64 c5.05,0,9.15,4.09,9.15,9.15v0C479.3,96.18,475.2,100.28,470.15,100.28z"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 437.9882 94.1204)",
    className: "st15 st53 st54"
  }, ".net")), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M458.69,382.35h-22.16c-2.22,0-4.02-1.8-4.02-4.02v-16.64c0-2.22,1.8-4.02,4.02-4.02h22.16 c2.22,0,4.02,1.8,4.02,4.02v16.64C462.72,380.55,460.92,382.35,458.69,382.35z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M431.63,375.2h-0.76c-0.49,0-0.88-0.39-0.88-0.88v-8.01c0-0.49,0.39-0.88,0.88-0.88h0.76 c0.49,0,0.88,0.39,0.88,0.88v8.01C432.51,374.8,432.12,375.2,431.63,375.2z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M446.03,357.65c1.7-0.75,1.26-5.58,1.26-5.58h0.82c0,0-0.6,5.21,1.1,5.58H446.03z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 447.61,
    cy: 350.6,
    r: 3.55
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M464.36,374.89h-0.76c-0.49,0-0.88-0.39-0.88-0.88V366c0-0.49,0.39-0.88,0.88-0.88h0.76 c0.49,0,0.88,0.39,0.88,0.88v8.01C465.24,374.49,464.85,374.89,464.36,374.89z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M458.26,368.85c-0.03-2.3-1.6-4.15-3.54-4.15c-1.94,0-3.52,1.85-3.54,4.15H458.26z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M444.76,368.85c-0.03-2.3-1.6-4.15-3.54-4.15c-1.94,0-3.52,1.85-3.54,4.15H444.76z"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st59",
    cx: 447.63,
    cy: 375.81,
    rx: 4.39,
    ry: 3.34
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionRpa);
export default __webpack_public_path__ + "static/media/solutionRPA.09924fbb375602dcaa20f9aef4cff912.svg";
export { ForwardRef as ReactComponent };